import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { I18N_FALLBACK_LNG, I18N_WHITELIST } from "./const";
import { LIST_LANGUAGE_ENUM } from "./constants";
import EN from "./locales/en/translation.json";
import ZHHK from "./locales/zh-HK/translation.json";
import ZHTW from "./locales/zh-TW/translation.json";
import JA from "./locales/ja/translation.json";

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
const resources = {
  [LIST_LANGUAGE_ENUM.EN]: { translation: EN },
  [LIST_LANGUAGE_ENUM.ZHHK]: { translation: ZHHK },
  [LIST_LANGUAGE_ENUM.ZHTW]: { translation: ZHTW },
  [LIST_LANGUAGE_ENUM.JA]: { translation: JA },
};

i18n
// eslint-disable-next-line
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: I18N_FALLBACK_LNG,
    debug: false,
    whitelist: I18N_WHITELIST,
    resources,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
